import PolicyPage from "@/components/shared/PolicyPage";
import { COMPANY } from "@/config/company";

const sections = [
  {
    h: "About these terms",
    p: [`These terms govern your use of sendtoo.in, the Sendtoo app and the logistics services provided by ${COMPANY.legalName} under the brand ${COMPANY.brand} ("we", "us"). By creating an account, booking a shipment or using the site you agree to them.`],
  },
  {
    h: "Our services",
    p: ["We arrange pickup, transport and delivery of parcels, cargo and part or full truck loads, domestically and internationally, using our own network and trusted partner carriers. Service availability depends on the pincodes, weight and goods involved."],
  },
  {
    h: "Your account",
    ul: [
      "You must give accurate and complete information and keep it up to date, including addresses, pincodes, phone numbers and GST details.",
      "You are responsible for activity under your account and for keeping your login details private.",
      "Business customers may be asked for KYC documents before credit or special rates are given.",
    ],
  },
  {
    h: "Booking, rates and payment",
    ul: [
      "Charges are based on the chargeable weight (the higher of actual and volumetric weight), distance, service type and applicable taxes and surcharges shown at booking or in your rate agreement.",
      "If the weight, dimensions or details you declared are found to be different at pickup or sorting, the charge is revised to match and the difference is payable.",
      "Payment is made through your Sendtoo wallet, online payment or, for approved customers, on the credit terms agreed in writing. Invoices are issued as per GST rules.",
    ],
  },
  {
    h: "Your responsibilities as sender",
    ul: [
      "Pack the goods securely and label them correctly with the full delivery address and a working phone number.",
      "Do not send prohibited or restricted items (see our Shipping & Service Policy).",
      "Provide the invoice, e-way bill and other documents the law requires for the goods and their value. You are responsible for the correctness of these documents.",
      "Check that the delivery pincode, city and address agree with each other. Delays, extra charges or cancellation caused by a wrong address are the sender's responsibility.",
    ],
  },
  {
    h: "Delivery",
    p: ["Delivery timelines are estimates, not guarantees, and can be affected by weather, strikes, festivals, road closures, regulatory checks and other events beyond our control. Please read the Shipping & Service Policy for details."],
  },
  {
    h: "Liability, loss and damage",
    ul: [
      "Unless you choose and pay for insurance or carrier-risk cover, shipments travel at owner's risk and our liability, if any, is limited as stated in the consignment note and the rules of the carrier handling the shipment.",
      "We are not liable for indirect or consequential loss, loss of profit or business, or for loss or damage caused by wrong or incomplete information, inadequate packing, or the nature of the goods.",
      "Claims must be raised in writing within the period stated in the Shipping & Service Policy, with the consignment number, invoice and photographs.",
    ],
  },
  {
    h: "Cancellations and refunds",
    p: ["Cancellations and refunds are governed by our Refund & Cancellation Policy."],
  },
  {
    h: "Messages",
    p: ["We contact you by phone, SMS, email and WhatsApp about your bookings. Promotional messages are sent only with your consent, which you can withdraw at any time by replying STOP. See our Privacy Policy."],
  },
  {
    h: "Acceptable use",
    p: ["Do not misuse the platform: no fraud, false bookings, attempts to break or overload the service, scraping, or sending unlawful goods. We may suspend or close accounts that do."],
  },
  {
    h: "Intellectual property",
    p: ["The Sendtoo name, logo, website content and software belong to us or our licensors. You may not copy or reuse them without written permission."],
  },
  {
    h: "Governing law and disputes",
    p: ["These terms are governed by the laws of India. Courts at Visakhapatnam, Andhra Pradesh have jurisdiction, subject to any mandatory consumer-protection rights you have. Please write to us first so we can try to resolve the issue."],
  },
  {
    h: "Changes",
    p: ["We may update these terms. Continued use of the service after an update means you accept the updated terms."],
  },
];

export default function TermsConditions() {
  return <PolicyPage testId="terms-page" title="Terms & Conditions" intro="Please read these terms before using Sendtoo." sections={sections} />;
}
